import { getToken } from '../../../../util/token';
import { configCountry } from '../../../../util/url-builder';

const base_url = configCountry()['extrenal_api'];

export const getBanners = (body) => {
    const url = `${base_url}/api/ms/web-proxy/banners/store-banners`;
    const token = getToken();

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
    })
        .then((response) => response && response.json())
        .then((json) => json && json['store_banners']);
};
